module.exports = __webpack_public_path__ + "static/work3-08e3d5ba9a7789eb93c74a932d484d65.jpg";